import { AddCalendarForDatePicker } from "components/app/AddCalendarForDatePicker";
import moment from "moment-timezone";
import React, { FC, useEffect, useRef, useState } from "react";
import OriginalFlatpickr from "react-flatpickr";
import { ControllerFieldState, ControllerRenderProps } from "react-hook-form/dist/types/controller";
const Flatpickr: any = OriginalFlatpickr;

const DueDate: FC<
  {
    field: ControllerRenderProps;
    fieldState: ControllerFieldState;
  } & {
    label: string;
    handleChange?: (selected: Date[]) => void;
    defaultOpen?: boolean;
    disabled?: boolean;
    zone?: string;
  }
> = ({ fieldState, field, label, defaultOpen = false, disabled = false, zone }) => {
  const [dueDate, setDueDate] = useState<Date | null>(field.value);
  const ref = useRef<any>();

  useEffect(() => {
    if (defaultOpen) {
      ref.current?.flatpickr?.open?.();
    }
  }, [defaultOpen]);

  return (
    <div>
      <p>
        <span>{label}</span>
      </p>

      <Flatpickr
        {...field}
        options={{
          mode: "single",
          dateFormat: "m/d/Y",
          animate: true,
          minDate: moment()
            .tz(zone || moment.tz.guess())
            .format("MM/DD/YYYY"),
        }}
        value={dueDate}
        onChange={(val: any) => {
          setDueDate(val);
          field.onChange(val);
        }}
        render={({ value: dueDate }: { value: Date | Date[] }, ref: React.Ref<HTMLInputElement>) =>
          AddCalendarForDatePicker(
            dueDate,
            ref,
            {
              width: "100%",
              height: "40px",
              textAlign: "left",
              borderRadius: "8px",
              border: "1px solid #bebaba",
              fontSize: 16,
              paddingLeft: 10,
              position: "relative",
            },
            { position: "absolute", right: 8, bottom: 6 },
            disabled
          )
        }
      />
      {!!fieldState.error ? <p style={{ color: "#f44336" }}>{fieldState.error?.message}</p> : null}
    </div>
  );
};

export default DueDate;
